import axios from 'axios';
import config from '../devprodConfig';
import heic2any from 'heic2any';

const API_URL = config.apiBaseUrl;

axios.interceptors.response.use(
  res => res,
  err => {
    if (err?.response?.status === 429) {
      const retryAfter = parseInt(err.response.headers['retry-after'] ?? '60', 10);
      window.dispatchEvent(new CustomEvent('ktp:ratelimit', { detail: { retryAfter } }));
    }
    return Promise.reject(err);
  }
);

export const searchKiinteistot = (kiinteistotunnus = '', osoite = '', kaupunki = '', filterByAddress = false) => {
  console.log(kiinteistotunnus, osoite, kaupunki);
  return axios.get(`${API_URL}/api/haku/hae-kiinteistoja`, {
    withCredentials: true,
    params: {
      kiinteistotunnus: kiinteistotunnus || undefined,
      osoite: osoite || undefined,
      kaupunki: kaupunki || undefined,
      filterByAddress: filterByAddress || undefined
    }
  });
};

export const getKiinteistot = () =>
  axios.get(`${API_URL}/api/kiinteistot`, {
    withCredentials: true
  });

export const getKiinteistotWithRakennukset = (
  page = 1,
  limit = 6,
  orderBy = 'id_kiinteisto',
  orderDir = 'ASC',
  searchTerm = '' 
  ) =>
  axios.get(`${API_URL}/api/kiinteistot/with-rakennukset`, {
    withCredentials: true,
    params: {
      page,
      limit,
      orderBy,
      orderDir,
      searchTerm: searchTerm, 
    },
  });
  
export const getKiinteistoWhole = (id) =>
  axios.get(`${API_URL}/api/kiinteistot/with-rakennukset/by/id/${id}`, {
    withCredentials: true
  })


export const createKiinteisto = (data) =>
  axios.post(
    `${API_URL}/api/kiinteistot/with-rakennukset`,
        {
      ...data,
      isDraft: true, 
    },

    {
      headers: {
        'Content-Type': 'application/json',
        
      },
      
      
      withCredentials: true,
    }
    
  );
export const createEmptyTaloyhtio = (data) =>
  axios.post(
    `${API_URL}/api/kiinteistot/with-rakennukset`,
    {
      isDraft: true,
      kohteen_nimi: '',
      rakennukset: [],
      ...data, 
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    }
  );
export const updateRakennus = (id, data) => {
  console.log('updateRakennus payload:', data);

  return axios.put(
    `${API_URL}/api/rakennukset_full/${id}/with-metadata`,  
    data,
    {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    }
  );
};
export const setSharePointFolderForKiinteisto = (kiinteistoId, folder) =>
  axios.post(
    `${API_URL}/sharepoint/folder/set`,
    {
      kiinteistoId,
      folderId: folder.id,
      folderName: folder.name
    },
    { withCredentials: true }
  );
export const unlinkSharePointFolder = (kiinteistoId) =>
  axios.post(
    `${API_URL}/sharepoint/folder/unlink`,
    { kiinteistoId },   
    { withCredentials: true }
  );
export const updateKiinteisto = (id, data) => {
  console.log('updateRakennus payload:', data);

  return axios.put(
    `${API_URL}/api/kiinteistot/with-metadata/${id}`,  
    data,
    {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    }
  );
};

// ===== WEATHER / FMI =====

export const getFmiWeather = ({
  lat,
  lon,
  date,
  startTime,
  endTime,
}) => {
  if (lat == null || lon == null) {
    throw new Error("Missing weather coordinates");
  }

  if (!date || !startTime) {
    throw new Error("Missing weather date or start time");
  }

  return axios.get(`${API_URL}/api/weather/fmi`, {
    withCredentials: true,
    params: {
      lat,
      lon,
      date,
      startTime,
      endTime: endTime || undefined,
    },
  });
};
export const getIndicatorValueByKuntaName = (indicatorId, kuntaName, years) => {
  return axios.get(`${API_URL}/api/tilastot/get-indicator-value-by-kunta-name`, {
    withCredentials: true,
    params: {
      indicatorId,
      kuntaName,
      years: years.join(','),
    }
  });
};

export const getFmiWeatherDay = ({
  lat,
  lon,
  date,
}) => {
  if (
    lat == null ||
    lon == null
  ) {
    throw new Error(
      "Missing weather coordinates"
    );
  }

  if (!date) {
    throw new Error(
      "Missing weather date"
    );
  }

  return axios.get(
    `${API_URL}/api/weather/fmi/day`,
    {
      withCredentials: true,

      params: {
        lat,
        lon,
        date,
      },
    }
  );
};


//Päivitä päärakennus muuttujaa true/false
export const patchIsMainBuilding = (id_rakennus, data) => {

  return axios.patch(
    `${API_URL}/api/rakennukset_full/by/mainbuilding/${id_rakennus}`,  
    data,
    {
      headers: {
        'Content-Type': 'application/json',
      },
      withCredentials: true,
    }
  );
};



// === RISK TABLES ===

// Get risk table(s) by kiinteisto id
export const getRiskTableByKiinteisto = (kiinteistoId) =>
  axios.get(`${API_URL}/api/risk_tables/by/id_kiinteisto/${kiinteistoId}`, {
    withCredentials: true
  });

// Create risk table from template for a kiinteisto
export const createRiskTableFromTemplate = (kiinteistoId) =>
  axios.post(`${API_URL}/api/risk_tables/from-template/${kiinteistoId}`, {}, {
    withCredentials: true
  });

// Update existing risk table by table id
export const updateRiskTable = (tableId, data) =>
  axios.put(`${API_URL}/api/risk_tables/${tableId}`, data, {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true
  });



// ===== MÄÄRÄAIKAISTARKASTUKSET =====
// Versioned (see useMaaraaikaistarkastusData.js) — only the current
// (newest) version is ever editable, older ones are read-only snapshots.

export const getMaaraaikaistarkastusVersiotByKiinteisto = (kiinteistoId) =>
  axios.get(`${API_URL}/api/maaraaikaistarkastukset/versiot/by/id_kiinteisto/${kiinteistoId}`, {
    withCredentials: true
  });

export const getMaaraaikaistarkastusVersio = (versioId) =>
  axios.get(`${API_URL}/api/maaraaikaistarkastukset/versiot/${versioId}`, {
    withCredentials: true
  });

export const createMaaraaikaistarkastusVersio = (data) =>
  axios.post(`${API_URL}/api/maaraaikaistarkastukset/versiot`, data, {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true
  });

export const deleteMaaraaikaistarkastusVersio = (id) =>
  axios.delete(`${API_URL}/api/maaraaikaistarkastukset/versiot/${id}`, {
    withCredentials: true
  });

export const createMaaraaikaistarkastusRyhma = (data) =>
  axios.post(`${API_URL}/api/maaraaikaistarkastukset/ryhmat`, data, {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true
  });

export const updateMaaraaikaistarkastusRyhma = (id, data) =>
  axios.put(`${API_URL}/api/maaraaikaistarkastukset/ryhmat/${id}`, data, {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true
  });

export const deleteMaaraaikaistarkastusRyhma = (id) =>
  axios.delete(`${API_URL}/api/maaraaikaistarkastukset/ryhmat/${id}`, {
    withCredentials: true
  });

export const createMaaraaikaistarkastusRivi = (data) =>
  axios.post(`${API_URL}/api/maaraaikaistarkastukset/rivit`, data, {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true
  });

export const updateMaaraaikaistarkastusRivi = (id, data) =>
  axios.put(`${API_URL}/api/maaraaikaistarkastukset/rivit/${id}`, data, {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true
  });

export const deleteMaaraaikaistarkastusRivi = (id) =>
  axios.delete(`${API_URL}/api/maaraaikaistarkastukset/rivit/${id}`, {
    withCredentials: true
  });


// ===== RAKENNUSLUVAT =====

export const getRakennusluvatByKiinteisto = (kiinteistoId) =>
  axios.get(`${API_URL}/api/rakennusluvat/by/id_kiinteisto/${kiinteistoId}`, {
    withCredentials: true
  });

export const createRakennuslupaRivi = (data) =>
  axios.post(`${API_URL}/api/rakennusluvat`, data, {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true
  });

export const updateRakennuslupaRivi = (id, data) =>
  axios.put(`${API_URL}/api/rakennusluvat/${id}`, data, {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true
  });

export const deleteRakennuslupaRivi = (id) =>
  axios.delete(`${API_URL}/api/rakennusluvat/${id}`, {
    withCredentials: true
  });


// ===== REPORTS =====
export const getAllReports = () =>
  axios.get(`${API_URL}/api/reports`, { withCredentials: true });

// Get reports grouped by kiinteisto with optional pagination
export const getReportsGroupedByKiinteisto = (page = 1, limit = 10) =>
  axios.get(`${API_URL}/api/reports/by-properties`, {
    withCredentials: true,
    params: { page, limit }
});

export const getAllTemplates = () =>
  axios.get(`${API_URL}/api/reports/templates`, { withCredentials: true });

export const getReportById = (id) =>
  axios.get(`${API_URL}/api/reports/by/id/${id}`, { withCredentials: true });

export const getReportsByKiinteisto = (id_kiinteisto) =>
  axios.get(`${API_URL}/api/reports/by/id_kiinteisto/${id_kiinteisto}`, { withCredentials: true });

export const getReportsByCreatedBy = (created_by) =>
  axios.get(`${API_URL}/api/reports/by/created_by/${created_by}`, { withCredentials: true });

export const getReportsByUpdatedBy = (updated_by) =>
  axios.get(`${API_URL}/api/reports/by/updated_by/${updated_by}`, { withCredentials: true });

export const createReport = (data) =>
  axios.post(`${API_URL}/api/reports`, data, { headers: { 'Content-Type': 'application/json' }, withCredentials: true });

export const updateReport = (id, data) =>
  axios.put(`${API_URL}/api/reports/${id}`, data, { headers: { 'Content-Type': 'application/json' }, withCredentials: true });

// Duplicate an existing template into a new template — all its sections
// (content, order) are copied, so a new template can start as a full copy
// of an existing one instead of an empty shell.
export const duplicateTemplate = ({ sourceTemplateId, name, type, userId }) =>
  axios.post(`${API_URL}/api/reports/templates/duplicate`, { sourceTemplateId, name, type, userId },
    { headers: { 'Content-Type': 'application/json' }, withCredentials: true });

// ✅ Set report state
export const updateReportState = (id, newState) =>
  updateReport(id, { state: newState });


export const deleteReport = (id) =>
  axios.delete(`${API_URL}/api/reports/${id}`, { withCredentials: true });

// Create or overwrite a report from a template
export const createOrOverwriteReportFromTemplate = (templateData) =>
  axios.post(`${API_URL}/api/reports/from-template`, templateData, { headers: { 'Content-Type': 'application/json' }, withCredentials: true });

// Create a report from a template type for a specific kiinteisto
export const createReportFromTemplateType = (id_kiinteisto, templateType, userId = 15) =>
  axios.post(`${API_URL}/api/reports/from-template-type`, { id_kiinteisto, templateType, userId }, { headers: { 'Content-Type': 'application/json' }, withCredentials: true });

export const getTemplateByType = (type) =>
  axios.get(`${API_URL}/api/reports/templates/${type}`, { withCredentials: true });

// Get users for a specific report
export const getReportUsers = (reportId) =>
  axios.get(`${API_URL}/api/report-users/report/${reportId}`, { withCredentials: true });

export const updateReportUsers = (reportId, users) =>
  axios.put(
    `${config.apiBaseUrl}/api/report-users/report/${reportId}`,
    { users },            // body
    { withCredentials: true } // include cookies/session
  );

export const getPagedReports = ({
  page = 1,
  limit = 10,
  sort = "latest",
  sortBy = "updated_at",
  type = "",
  ownReports = false,
  showReadyReports = true,
  showNonReadyReports = true
}) =>
  axios.get(`${API_URL}/api/reports/paged`, {
    withCredentials: true,
    params: {
      page,
      limit,
      sort,
      sortBy,
      type,
      ownReports: ownReports ? true : undefined,
      showReadyReports,
      showNonReadyReports
    },
  });
export const getSharePointFolderByKiinteisto = (
  osoite,
  postinumero,
  kaupunki,
  kiinteistoId
) =>
  axios.get(`${API_URL}/sharepoint/folder/by-kiinteisto`, {
    withCredentials: true,
    params: {
      osoite,
      postinumero,
      kaupunki,
      kiinteistoId 
    }
  });
// Move report to another kiinteistö
export const changeReportKiinteisto = (reportId, newKiinteistoId) =>
  axios.put(
    `${API_URL}/api/reports/${reportId}/change-kiinteisto`,
    { newKiinteistoId },
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );
export const sendEmailGraph = (data) =>
  axios.post(
    `${config.apiBaseUrl}/api/email/send-email-graph`,
    data,
    { withCredentials: true }
  );
// ===== REPORT_SECTIONS =====
export const getAllReportSections = () =>
  axios.get(`${API_URL}/api/report_sections`, { withCredentials: true });

export const getReportSectionById = (id) =>
  axios.get(`${API_URL}/api/report_sections/by/id/${id}`, { withCredentials: true });

export const getReportSectionsByReportId = (report_id) =>
  axios.get(`${API_URL}/api/report_sections/by/report_id/${report_id}`, { withCredentials: true });

export const getReportSectionsByCreatedBy = (created_by) =>
  axios.get(`${API_URL}/api/report_sections/by/created_by/${created_by}`, { withCredentials: true });

export const getReportSectionsByUpdatedBy = (updated_by) =>
  axios.get(`${API_URL}/api/report_sections/by/updated_by/${updated_by}`, { withCredentials: true });

export const getReportSectionsByEditLock = (edit_lock) =>
  axios.get(`${API_URL}/api/report_sections/by/edit_lock/${edit_lock}`, { withCredentials: true });

export const createReportSection = (data) =>
  axios.post(`${API_URL}/api/report_sections`, data, { headers: { 'Content-Type': 'application/json' }, withCredentials: true });

// Create a new section for an existing report (used for "Lisää osio" button)
export const createSectionForReport = (data) =>
  axios.post(`${API_URL}/api/report_sections/createSection`, data, { headers: { 'Content-Type': 'application/json' }, withCredentials: true });

export const updateReportSection = (id, data) =>
  axios.put(`${API_URL}/api/report_sections/${id}`, data, { headers: { 'Content-Type': 'application/json' }, withCredentials: true });

export const updateReportSectionState = (id, newState) =>
  updateReportSection(id, { state: newState });

export const deleteReportSection = (id) =>
  axios.delete(`${API_URL}/api/report_sections/${id}`, { withCredentials: true });



// ===== KIINTEISTO IMAGES =====

// Move all images from one kiinteisto to another
export const moveImagesToAnotherKiinteisto = (fromKiinteistoId, toKiinteistoId) => {
  if (!fromKiinteistoId || !toKiinteistoId) {
    throw new Error("Both fromKiinteistoId and toKiinteistoId are required");
  }

  return axios.post(
    `${API_URL}/api/kiinteisto_images/move`,
    { fromKiinteistoId, toKiinteistoId },
    { 
      headers: { "Content-Type": "application/json" },
      withCredentials: true 
    }
  );
};

// Get all images
export const getAllKiinteistoImages = () =>
  axios.get(`${API_URL}/api/kiinteisto_images`, { withCredentials: true });

// Get image by ID
export const getKiinteistoImageById = (id) =>
  axios.get(`${API_URL}/api/kiinteisto_images/by/id/${id}`, { withCredentials: true });

// Get images by created_by
export const getKiinteistoImagesByCreatedBy = (created_by) =>
  axios.get(`${API_URL}/api/kiinteisto_images/by/created_by/${created_by}`, { withCredentials: true });

// Get images by updated_by
export const getKiinteistoImagesByUpdatedBy = (updated_by) =>
  axios.get(`${API_URL}/api/kiinteisto_images/by/updated_by/${updated_by}`, { withCredentials: true });

// Get autograph images for a user
export const getAutographImagesByUserId = (user_id) =>
  axios.get(`${API_URL}/api/kiinteisto_images/by/user/${user_id}`, {
    withCredentials: true,
  });


export const uploadAutographImageSas = async (file, userId) => {
  if (!file || !userId) throw new Error("Missing required parameters");

  // --- Delete old autograph(s) ---
  const existing = await getAutographImagesByUserId(userId);
  if (existing?.data?.length) {
    for (const img of existing.data) {
      try {
        await deleteKiinteistoImage(img.id);
      } catch (err) {
        console.warn(`Failed to delete old autograph ${img.id}:`, err);
      }
    }
  }

  // --- Upload new image ---
  const blobName = `autograph/${userId}/${crypto.randomUUID()}-${file.name.replace(/\s+/g, "_")}`;

  const { data } = await getKiinteistoSasToken(blobName);
  const { sasUrl } = data;

  // Upload to Azure
  await fetch(sasUrl, {
    method: "PUT",
    body: file,
    headers: { "x-ms-blob-type": "BlockBlob" },
  });

  // Create DB record with user_id
  const createdRecord = await createKiinteistoImage({
    id_kiinteisto: null,
    user_id: userId,
    azure_blob_name: blobName,
    metadata: {
      description: "",
      flipped: false,
      category: "autograph",
      originalName: file.name,
    },
    created_by: userId,
    updated_by: userId,
  });

  return createdRecord.data;
};

// Get images by kiinteisto ID and category
export const getKiinteistoImagesByKiinteistoId = (
  id_kiinteisto,
  { category = null, subCategory=null ,page = 1, limit = 9999 } = {}
) => {
  const url = `${API_URL}/api/kiinteisto_images/by/id_kiinteisto/${id_kiinteisto}`;

  const params = { page, limit };

  if (category) params.category = category;
  if (subCategory) params.subCategory = subCategory; 

  return axios.get(url, {
    params,
    withCredentials: true,
  });
};

// Create new image record (metadata only)
export const createKiinteistoImage = (data) =>
  axios.post(`${API_URL}/api/kiinteisto_images`, data, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });

// Update image metadata
export const updateKiinteistoImage = (id, data) =>
  axios.put(`${API_URL}/api/kiinteisto_images/${id}`, data, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });

// Delete image (also triggers blob deletion in backend)
export const deleteKiinteistoImage = (id) =>
  axios.delete(`${API_URL}/api/kiinteisto_images/${id}`, { withCredentials: true });

// ===== AZURE BLOB SAS TOKEN =====

// Request SAS token (backend route: GET /api/kiinteisto_images/sas)
export const getKiinteistoSasToken = (blobName) =>
  axios.post(
    `${API_URL}/api/kiinteisto_images/sas`,
    { blobName },
    { withCredentials: true }
  );

// ===== COMBINED UPLOAD FLOW =====
/**
 * Uploads a file to Azure Blob via SAS and creates DB record.
 * @param {File} file - image file to upload
 * @param {number} kiinteistoId - related kiinteisto
 * @param {number} userId - creator/updater user ID
 */
// A thrown error is tagged `isNetworkError` so callers (the offline image
// queue) can tell "never reached a server" (genuine connectivity failure —
// worth queuing for later retry) apart from "a server responded, just with
// an error" (expired session, validation error, 5xx, rate limit — retrying
// later without addressing the real cause won't help, so it shouldn't be
// silently queued as if it were an offline problem).
const markNetworkError = (err, isNetworkError) => {
  err.isNetworkError = isNetworkError;
  return err;
};

export const uploadKiinteistoImage = async (file, kiinteistoId, userId, category, subCategory) => {
  if (!file || !kiinteistoId) throw new Error("Missing required parameters");

  // Convert HEIC/HEIF to JPEG before upload — most browsers can't display HEIC
  const isHeic = /heic|heif/i.test(file.type) || /\.(heic|heif)$/i.test(file.name);
  let uploadFile = file;
  let uploadName = file.name;
  if (isHeic) {
    try {
      const converted = await heic2any({ blob: file, toType: "image/jpeg", quality: 0.92 });
      const jpeg = Array.isArray(converted) ? converted[0] : converted;
      uploadName = file.name.replace(/\.(heic|heif)$/i, ".jpg");
      uploadFile = new File([jpeg], uploadName, { type: "image/jpeg" });
    } catch (err) {
      console.error("HEIC conversion failed, uploading original:", err);
    }
  }

  const blobName = `${kiinteistoId}/${crypto.randomUUID()}-${uploadName.replace(/\s+/g, "_")}`;

  let sasUrl;
  try {
    const { data } = await getKiinteistoSasToken(blobName);
    sasUrl = data.sasUrl;
  } catch (err) {
    // axios: a response came back (even an error one) means we reached a
    // server — only "no response at all" indicates a real connectivity problem.
    throw markNetworkError(err, !err.response);
  }

  let putResponse;
  try {
    putResponse = await fetch(sasUrl, {
      method: "PUT",
      body: uploadFile,
      headers: { "x-ms-blob-type": "BlockBlob" },
    });
  } catch (err) {
    // fetch only throws (TypeError: Failed to fetch) when the request never
    // reached a server at all — a genuine network failure.
    throw markNetworkError(err, true);
  }
  if (!putResponse.ok) {
    // We got an HTTP response from Azure (e.g. 403 on an expired SAS token)
    // — connectivity is fine, this just isn't a successful upload. Without
    // this check the code used to fall through and create a DB record
    // pointing at a blob that was never actually written.
    throw markNetworkError(new Error(`Kuvan lataus Azureen epäonnistui (${putResponse.status})`), false);
  }

  try {
    const createdRecord = await createKiinteistoImage({
      id_kiinteisto: kiinteistoId,
      azure_blob_name: blobName,
      metadata: {
        description: "",
        flipped: false,
        category: category || "",
        subCategory: subCategory || "",
        originalName: file.name,
      },
      created_by: userId,
      updated_by: userId,
    });
    return createdRecord.data;
  } catch (err) {
    throw markNetworkError(err, !err.response);
  }
};

// Reorder images within a kiinteisto/category/subCategory
export const reorderKiinteistoImages = ({ id_kiinteisto, category, subCategory, orderedIds }) => {
  if (!id_kiinteisto || !Array.isArray(orderedIds) || orderedIds.length === 0) {
    throw new Error("Missing required parameters for reordering");
  }

  return axios.post(
    `${API_URL}/api/kiinteisto_images/reorder`,
    { id_kiinteisto, category, subCategory, orderedIds },
    { withCredentials: true }
  );
};

// ===== YHTEYSHENKILOT =====

// Get all yhteyshenkilot
export const getAllYhteyshenkilot = () =>
  axios.get(`${API_URL}/api/yhteyshenkilot`, { withCredentials: true });

// Get a single yhteyshenkilot by ID
export const getYhteyshenkilotById = (id) =>
  axios.get(`${API_URL}/api/yhteyshenkilot/by/id/${id}`, { withCredentials: true });

// Get yhteyshenkilot by kiinteisto ID
export const getYhteyshenkilotByKiinteistoId = (id_kiinteisto) =>
  axios.get(`${API_URL}/api/yhteyshenkilot/by/id_kiinteisto/${id_kiinteisto}`, { withCredentials: true });

// Create a new yhteyshenkilot
export const createYhteyshenkilot = (data) =>
  axios.post(`${API_URL}/api/yhteyshenkilot`, data, {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
  });

// Update an existing yhteyshenkilot by ID
export const updateYhteyshenkilot = (id, data) =>
  axios.put(`${API_URL}/api/yhteyshenkilot/${id}`, data, {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
  });

// Delete a yhteyshenkilot by ID
export const deleteYhteyshenkilot = (id) =>
  axios.delete(`${API_URL}/api/yhteyshenkilot/${id}`, { withCredentials: true });

//PTS labelien haku

export const getLabelsByCategoryAndSection = (category = '', section = '') => {
  //Normalization table to match database categories
  const categoryMap = {
    "Sähkötekniikka": "Sähköjärjestelmät",
    "LVI-tekniikka": "LVI Järjestelmät",
  };

  const normalizedCategory = categoryMap[category] || category;

  return axios.get(`${API_URL}/api/pts/by/get-labels-by-category-and-section`, {
    withCredentials: true,
    params: {
      category: normalizedCategory || undefined,
      section: section || undefined,
    },
  });
};

// === USERS ===

// Get current logged-in user
export const getMe = () =>
  axios.get(`${API_URL}/api/users/me`, { withCredentials: true });

// Get all users
export const getAllUsers = () =>
  axios.get(`${API_URL}/api/users`, { withCredentials: true });

// Get user by ID
export const getUserById = (id) =>
  axios.get(`${API_URL}/api/users/${id}`, { withCredentials: true });

// Get user by email
export const getUserByEmail = (email) =>
  axios.get(`${API_URL}/api/users/by/email/${email}`, { withCredentials: true });

// Create new user
export const createUser = (data) =>
  axios.post(`${API_URL}/api/users`, data, {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
  });

// Update user
export const updateUser = (id, data) =>
  axios.put(`${API_URL}/api/users/${id}`, data, {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
  });

// Delete user
export const deleteUser = (id) =>
  axios.delete(`${API_URL}/api/users/${id}`, { withCredentials: true });


// ============================================================
// KOULUTUKSET
// ============================================================

export const getKoulutukset = async (userId) => {
  const response = await fetch(
    `${API_URL}/api/users/${userId}/koulutukset`,
    {
      credentials: "include",
    }
  );

  if (!response.ok) {
    throw new Error("Koulutusten haku epäonnistui");
  }

  return response.json();
};

export const createKoulutus = async (userId, data) => {
  const response = await fetch(
    `${API_URL}/api/users/${userId}/koulutukset`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(data),
    }
  );

  if (!response.ok) {
    throw new Error("Koulutuksen lisääminen epäonnistui");
  }

  return response.json();
};

export const updateKoulutus = async (id, data) => {
  const response = await fetch(
    `${API_URL}/api/koulutukset/${id}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(data),
    }
  );

  if (!response.ok) {
    throw new Error("Koulutuksen päivittäminen epäonnistui");
  }

  return response.json();
};

export const deleteKoulutus = async (id) => {
  const response = await fetch(
    `${API_URL}/api/koulutukset/${id}`,
    {
      method: "DELETE",
      credentials: "include",
    }
  );

  if (!response.ok) {
    throw new Error("Koulutuksen poistaminen epäonnistui");
  }

  return true;
};
// ============================================================
// KURSSIT
// ============================================================

export const getKurssit = async (userId) => {
  const response = await fetch(
    `${config.apiBaseUrl}/api/users/${userId}/kurssit`,
    {
      method: "GET",
      credentials: "include",
    }
  );

  if (!response.ok) {
    throw new Error("Kurssien haku epäonnistui");
  }

  return response.json();
};

export const createKurssi = async (userId, data) => {
  const response = await fetch(
    `${config.apiBaseUrl}/api/users/${userId}/kurssit`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(data),
    }
  );

  if (!response.ok) {
    throw new Error("Kurssin lisääminen epäonnistui");
  }

  return response.json();
};

export const updateKurssi = async (id, data) => {
  const response = await fetch(
    `${config.apiBaseUrl}/api/kurssit/${id}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(data),
    }
  );

  if (!response.ok) {
    throw new Error("Kurssin päivittäminen epäonnistui");
  }

  return response.json();
};

export const deleteKurssi = async (id) => {
  const response = await fetch(
    `${config.apiBaseUrl}/api/kurssit/${id}`,
    {
      method: "DELETE",
      credentials: "include",
    }
  );

  if (!response.ok) {
    throw new Error("Kurssin poistaminen epäonnistui");
  }

  return true;
};



// ============================================================
// IT-LAITTEET
// ============================================================

export const getItLaitteet = async (userId) => {
  const response = await fetch(
    `${config.apiBaseUrl}/api/users/${userId}/it-laitteet`,
    {
      method: "GET",
      credentials: "include",
    }
  );

  if (!response.ok) {
    throw new Error("IT-laitteiden haku epäonnistui");
  }

  return response.json();
};


export const createItLaite = async (userId, data) => {
  const response = await fetch(
    `${config.apiBaseUrl}/api/users/${userId}/it-laitteet`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(data),
    }
  );

  if (!response.ok) {
    throw new Error("IT-laitteen lisääminen epäonnistui");
  }

  return response.json();
};


export const updateItLaite = async (id, data) => {
  const response = await fetch(
    `${config.apiBaseUrl}/api/it-laitteet/${id}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(data),
    }
  );

  if (!response.ok) {
    throw new Error("IT-laitteen päivittäminen epäonnistui");
  }

  return response.json();
};


export const deleteItLaite = async (id) => {
  const response = await fetch(
    `${config.apiBaseUrl}/api/it-laitteet/${id}`,
    {
      method: "DELETE",
      credentials: "include",
    }
  );

  if (!response.ok) {
    throw new Error("IT-laitteen poistaminen epäonnistui");
  }

  return true;
};
// ============================================================
// LAITEHALLINTA
// ============================================================

export const getLaitteet = async (userId) => {
  const response = await fetch(
    `${config.apiBaseUrl}/api/users/${userId}/laitteet`,
    {
      method: "GET",
      credentials: "include",
    }
  );

  if (!response.ok) {
    throw new Error("Laitteiden haku epäonnistui");
  }

  return response.json();
};

export const createLaite = async (userId, data) => {
  const response = await fetch(
    `${config.apiBaseUrl}/api/users/${userId}/laitteet`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(data),
    }
  );

  if (!response.ok) {
    throw new Error("Laitteen lisäys epäonnistui");
  }

  return response.json();
};

export const updateLaite = async (id, data) => {
  const response = await fetch(
    `${config.apiBaseUrl}/api/laitteet/${id}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(data),
    }
  );

  if (!response.ok) {
    throw new Error("Laitteen päivitys epäonnistui");
  }

  return response.json();
};

export const deleteLaite = async (id) => {
  const response = await fetch(
    `${config.apiBaseUrl}/api/laitteet/${id}`,
    {
      method: "DELETE",
      credentials: "include",
    }
  );

  if (!response.ok) {
    throw new Error("Laitteen poisto epäonnistui");
  }

  return true;
};
// ============================================================
// HENKILÖN REFERENSSIT
// ============================================================

export const getReferenssit = async (userId) => {
  const res = await fetch(
    `${API_URL}/api/users/${userId}/referenssit`,
    {
      method: "GET",
      credentials: "include",
    }
  );

  if (!res.ok) {
    const text = await res.text();
    console.error("getReferenssit:", res.status, text);

    throw new Error(
      `Referenssien haku epäonnistui (${res.status}): ${text}`
    );
  }

  return res.json();
};

export const createReferenssi = async (userId, data) => {
  const res = await fetch(
    `${API_URL}/api/users/${userId}/referenssit`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(data),
    }
  );

  if (!res.ok) {
    const text = await res.text();
    console.error("createReferenssi:", res.status, text);

    throw new Error(
      `Referenssin lisäys epäonnistui (${res.status}): ${text}`
    );
  }

  return res.json();
};

export const updateReferenssi = async (id, data) => {
  const res = await fetch(
    `${API_URL}/api/referenssit/${id}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(data),
    }
  );

  if (!res.ok) {
    const text = await res.text();
    console.error("updateReferenssi:", res.status, text);

    throw new Error(
      `Referenssin päivitys epäonnistui (${res.status}): ${text}`
    );
  }

  return res.json();
};

export const deleteReferenssi = async (id) => {
  const res = await fetch(
    `${API_URL}/api/referenssit/${id}`,
    {
      method: "DELETE",
      credentials: "include",
    }
  );

  if (!res.ok) {
    const text = await res.text();
    console.error("deleteReferenssi:", res.status, text);

    throw new Error(
      `Referenssin poisto epäonnistui (${res.status}): ${text}`
    );
  }

  return true;
};


// ============================================================
// YRITYKSEN REFERENSSIT
// ============================================================

export const getYritysReferenssit = async () => {
  const res = await fetch(
    `${API_URL}/api/yritys-referenssit`,
    {
      method: "GET",
      credentials: "include",
    }
  );

  if (!res.ok) {
    const text = await res.text();
    console.error("getYritysReferenssit:", res.status, text);

    throw new Error(
      `Yritysreferenssien haku epäonnistui (${res.status}): ${text}`
    );
  }

  return res.json();
};

export const createYritysReferenssi = async (data) => {
  const res = await fetch(
    `${API_URL}/api/yritys-referenssit`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(data),
    }
  );

  if (!res.ok) {
    const text = await res.text();
    console.error("createYritysReferenssi:", res.status, text);

    throw new Error(
      `Yritysreferenssin lisäys epäonnistui (${res.status}): ${text}`
    );
  }

  return res.json();
};

export const updateYritysReferenssi = async (id, data) => {
  const res = await fetch(
    `${API_URL}/api/yritys-referenssit/${id}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(data),
    }
  );

  if (!res.ok) {
    const text = await res.text();
    console.error("updateYritysReferenssi:", res.status, text);

    throw new Error(
      `Yritysreferenssin päivitys epäonnistui (${res.status}): ${text}`
    );
  }

  return res.json();
};

export const deleteYritysReferenssi = async (id) => {
  const res = await fetch(
    `${API_URL}/api/yritys-referenssit/${id}`,
    {
      method: "DELETE",
      credentials: "include",
    }
  );

  if (!res.ok) {
    const text = await res.text();
    console.error("deleteYritysReferenssi:", res.status, text);

    throw new Error(
      `Yritysreferenssin poisto epäonnistui (${res.status}): ${text}`
    );
  }

  return true;
};
// ============================================================
// HUOLTOHISTORIA
// ============================================================

export const getHuollot = async (laiteId) => {
  const response = await fetch(
    `${config.apiBaseUrl}/api/laitteet/${laiteId}/huollot`,
    {
      method: "GET",
      credentials: "include",
    }
  );

  if (!response.ok) {
    throw new Error("Huoltohistorian haku epäonnistui");
  }

  return response.json();
};

export const createHuolto = async (laiteId, data) => {
  const response = await fetch(
    `${config.apiBaseUrl}/api/laitteet/${laiteId}/huollot`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(data),
    }
  );

  if (!response.ok) {
    throw new Error("Huollon lisäys epäonnistui");
  }

  return response.json();
};

export const updateHuolto = async (id, data) => {
  const response = await fetch(
    `${config.apiBaseUrl}/api/huollot/${id}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(data),
    }
  );

  if (!response.ok) {
    throw new Error("Huollon päivitys epäonnistui");
  }

  return response.json();
};

export const deleteHuolto = async (id) => {
  const response = await fetch(
    `${config.apiBaseUrl}/api/huollot/${id}`,
    {
      method: "DELETE",
      credentials: "include",
    }
  );

  if (!response.ok) {
    throw new Error("Huollon poisto epäonnistui");
  }

  return true;
};
// ============================================================
// PÄTEVYYDET
// ============================================================

export const getPatevyydet = async (userId) => {
  const response = await fetch(
    `${API_URL}/api/users/${userId}/patevyydet`,
    {
      credentials: "include",
    }
  );

  if (!response.ok) {
    throw new Error("Pätevyyksien haku epäonnistui");
  }

  return response.json();
};

export const createPatevyys = async (userId, data) => {
  const response = await fetch(
    `${API_URL}/api/users/${userId}/patevyydet`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(data),
    }
  );

  if (!response.ok) {
    throw new Error("Pätevyyden lisääminen epäonnistui");
  }

  return response.json();
};

export const updatePatevyys = async (id, data) => {
  const response = await fetch(
    `${API_URL}/api/patevyydet/${id}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(data),
    }
  );

  if (!response.ok) {
    throw new Error("Pätevyyden päivittäminen epäonnistui");
  }

  return response.json();
};

export const deletePatevyys = async (id) => {
  const response = await fetch(
    `${API_URL}/api/patevyydet/${id}`,
    {
      method: "DELETE",
      credentials: "include",
    }
  );

  if (!response.ok) {
    throw new Error("Pätevyyden poistaminen epäonnistui");
  }

  return true;
};


// ============================================================
// KIELITAIDOT
// ============================================================

export const getKielitaidot = async (userId) => {
  const response = await fetch(
    `${API_URL}/api/users/${userId}/kielitaidot`,
    {
      credentials: "include",
    }
  );

  if (!response.ok) {
    throw new Error("Kielitaitojen haku epäonnistui");
  }

  return response.json();
};

export const createKielitaito = async (userId, data) => {
  const response = await fetch(
    `${API_URL}/api/users/${userId}/kielitaidot`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(data),
    }
  );

  if (!response.ok) {
    throw new Error("Kielitaidon lisääminen epäonnistui");
  }

  return response.json();
};

export const updateKielitaito = async (id, data) => {
  const response = await fetch(
    `${API_URL}/api/kielitaidot/${id}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(data),
    }
  );

  if (!response.ok) {
    throw new Error("Kielitaidon päivittäminen epäonnistui");
  }

  return response.json();
};

export const deleteKielitaito = async (id) => {
  const response = await fetch(
    `${API_URL}/api/kielitaidot/${id}`,
    {
      method: "DELETE",
      credentials: "include",
    }
  );

  if (!response.ok) {
    throw new Error("Kielitaidon poistaminen epäonnistui");
  }

  return true;
};


// ============================================================
// TYÖKOKEMUKSET
// ============================================================

export const getTyokokemukset = async (userId) => {
  const response = await fetch(
    `${API_URL}/api/users/${userId}/tyokokemukset`,
    {
      credentials: "include",
    }
  );

  if (!response.ok) {
    throw new Error("Työkokemusten haku epäonnistui");
  }

  return response.json();
};

export const createTyokokemus = async (userId, data) => {
  const response = await fetch(
    `${API_URL}/api/users/${userId}/tyokokemukset`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(data),
    }
  );

  if (!response.ok) {
    throw new Error("Työkokemuksen lisääminen epäonnistui");
  }

  return response.json();
};

export const updateTyokokemus = async (id, data) => {
  const response = await fetch(
    `${API_URL}/api/tyokokemukset/${id}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(data),
    }
  );

  if (!response.ok) {
    throw new Error("Työkokemuksen päivittäminen epäonnistui");
  }

  return response.json();
};

export const deleteTyokokemus = async (id) => {
  const response = await fetch(
    `${API_URL}/api/tyokokemukset/${id}`,
    {
      method: "DELETE",
      credentials: "include",
    }
  );

  if (!response.ok) {
    throw new Error("Työkokemuksen poistaminen epäonnistui");
  }

  return true;
};

// ===== RADON =====

export const getRadonByPostinumero = (postinumero) =>
  axios.get(
    `${API_URL}/api/radon/${postinumero}`,
    { withCredentials: true }
  );



//Energia
export const getEnergiaTablesByKiinteisto = (id_kiinteisto) => {
  if (!id_kiinteisto) throw new Error("Missing kiinteisto ID");
  
  return axios.get(`${API_URL}/api/energia_tables/by/id_kiinteisto/${id_kiinteisto}`, {
    withCredentials: true,
  });
};

// Update energia table by table ID
export const updateEnergiaTable = (tableId, data) => {
  if (!tableId) throw new Error("Missing energia table ID");
  
  return axios.put(`${API_URL}/api/energia_tables/${tableId}`, data, {
    headers: { "Content-Type": "application/json" },
    withCredentials: true,
  });
};


//PTS


/*
 * Get one full PTS by ID
 */
export const getPTSById = (id) =>
  axios.get(
    `${API_URL}/api/pts/${id}`,
    { withCredentials: true }
  );


/**
 * Get all PTS records by kiinteistötunnus
 */
export const getPTSByKiinteistotunnus = (kiinteistotunnus) =>
  axios.get(
    `${API_URL}/api/pts/by/kiinteistotunnus/${kiinteistotunnus}`,
    { withCredentials: true }
  );

/**
 * Get one full PTS by ID
 */
export const getPTSByKiinteistoId = (kiinteistoId) =>
  axios.get(
    `${API_URL}/api/pts/by/kiinteistoId/${kiinteistoId}`,
    { withCredentials: true }
  );


// Save or update a PTS record

export const savePTS = (payload, existingPTSId = null) => {
  const url = existingPTSId
    ? `${API_URL}/api/pts/${existingPTSId}`
    : `${API_URL}/api/pts`;

  return axios({
    method: existingPTSId ? 'put' : 'post',
    url,
    data: payload,
    withCredentials: true
  });
};


/**
 * Update a single block in energia table locally and send to backend
 * @param {Object} energiaTables - Current table object
 * @param {number} blockIndex - Index of block to update
 * @param {Object} updatedBlock - New block data
 * @returns {Promise} Axios PUT request
 */
export const saveEnergiaBlock = (energiaTables, blockIndex, updatedBlock) => {
  if (!energiaTables?.id) throw new Error("Missing energia table");

  // clone table to avoid mutation
  const updated = structuredClone(energiaTables);

  // update only one block
  updated.data.blocks[blockIndex] = {
    ...updated.data.blocks[blockIndex],
    ...updatedBlock,
    title: updated.data.blocks[blockIndex].title, // preserve original title
  };

  return updateEnergiaTable(energiaTables.id, { data: updated.data });
};


// ===== TOIMENPITEET =====

// Get all toimenpiteet
export const getAllToimenpiteet = () =>
  axios.get(`${API_URL}/api/toimenpiteet`, {
    withCredentials: true,
  });

// Get single toimenpide by ID
export const getToimenpideById = (id) =>
  axios.get(`${API_URL}/api/toimenpiteet/${id}`, {
    withCredentials: true,
  });

// Create single toimenpide
export const createToimenpide = (data) =>
  axios.post(
    `${API_URL}/api/toimenpiteet`,
    data,
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );

// Update full toimenpide row
export const updateToimenpide = (id, data) =>
  axios.put(
    `${API_URL}/api/toimenpiteet/${id}`,
    data,
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );

// Delete toimenpide
export const deleteToimenpide = (id) =>
  axios.delete(`${API_URL}/api/toimenpiteet/${id}`, {
    withCredentials: true,
  });

  // Create multiple toimenpiteet in bulk
export const createToimenpiteetBulk = (report_id, kiinteisto_id, groupedToimenpiteet) =>
  axios.post(
    `${API_URL}/api/toimenpiteet/bulk`,
    {"report_id": report_id,
      "kiinteisto_id" : kiinteisto_id,
      groupedToimenpiteet
    },
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );

  // ---- Field-specific updates ----

export const patchToimenpideKategoria = (id, kategoria) =>
  axios.patch(
    `${API_URL}/api/toimenpiteet/${id}/kategoria`,
    { kategoria },
    { withCredentials: true }
  );

export const patchToimenpideAlakategoria = (id, alakategoria) =>
  axios.patch(
    `${API_URL}/api/toimenpiteet/${id}/alakategoria`,
    { alakategoria },
    { withCredentials: true }
  );

export const patchToimenpideMerkittava = (id, merkittava) =>
  axios.patch(
    `${API_URL}/api/toimenpiteet/${id}/merkittava`,
    { merkittava },
    { withCredentials: true }
  );

export const patchToimenpideValiton = (id, valiton) =>
  axios.patch(
    `${API_URL}/api/toimenpiteet/${id}/valiton`,
    { valiton },
    { withCredentials: true }
  );

export const patchToimenpideContent = (id, content) =>
  axios.patch(
    `${API_URL}/api/toimenpiteet/${id}/content`,
    { content },
    { withCredentials: true }
  );

  // Get toimenpiteet by foreign key
export const getToimenpiteetByForeignKey = (fk, value, category = null, subCategory = null) => {
  const params = {};
  if (category) params.category = category;
  if (subCategory) params.subCategory = subCategory;

  return axios.get(`${API_URL}/api/toimenpiteet/foreign/${fk}/${value}`, {
    withCredentials: true,
    params, // axios automatically converts this to query string
  });
};

// Find toimenpiteet by criteria object
export const findToimenpiteetByCriteria = (criteria) =>
  axios.post(
    `${API_URL}/api/toimenpiteet/criteria`,
    criteria,
    { withCredentials: true }
  );

export const fetchMapImage = async ({
  lat,
  lng,
  markers,
  zoom = 16,
  layer = 'osm',
  overlay = 'kiinteistojaotus',
  width = 942,
  height = 624
}) => {
  if (!markers?.length) {
    throw new Error("markers required (must match working fetch behavior)");
  }

  // ✅ Build query EXACTLY like your working fetch
  const query = `lat=${lat}&lng=${lng}&zoom=${zoom}&layer=${layer}&overlay=${overlay}&width=${width}&height=${height}&markers=${encodeURIComponent(JSON.stringify(markers))}`;

  const response = await axios.get(
    `${API_URL}/api/kartat/fetch-map-image?${query}`,
    {
      responseType: 'blob', // ✅ SAME as fetch().blob()
      withCredentials: true
    }
  );

  // ✅ Convert blob → base64 EXACTLY like your working code
  const base64 = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(response.data);
  });

  return base64;
};

// -------------------- Report Section Versions --------------------
export const getAllSectionVersions = (sectionId, { light=true } = {}) =>
  axios.get(`${API_URL}/api/report_section_versions`, {
    params: { sectionId, light },
    withCredentials: true,
  });

export const getLatestSectionVersion = (sectionId, { light } = {}) =>
  axios.get(`${API_URL}/api/report_section_versions/latest/${sectionId}`, {
    params: { light },
    withCredentials: true,
  });

export const getSectionVersionById = (versionId) =>
  axios.get(`${API_URL}/api/report_section_versions/${versionId}`, {
    withCredentials: true,
  });

export const createSectionVersion = (data) =>
  axios.post(`${API_URL}/api/report_section_versions`, data, {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
  });

export const getOrCreateLatestSectionVersion = (data) =>
  axios.post(`${API_URL}/api/report_section_versions/or-create`, data, {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
  });


// ===== KOHO ERP =====

export const getKohoProjects = (params = {}) =>
  axios.get(`${API_URL}/api/koho-proxy/projects`, {
    withCredentials: true,
    params: { archived: false, limit: 200, ...params },
  });

export const getKohoCustomers = (params = {}) =>
  axios.get(`${API_URL}/api/koho-proxy/customers`, {
    withCredentials: true,
    params: { active: true, limit: 200, ...params },
  });

export const getKohoCustomerById = (customerId) =>
  axios.get(`${API_URL}/api/koho-proxy/customers/${customerId}`, {
    withCredentials: true,
  });

export const getKohoInvoices = (params = {}) =>
  axios.get(`${API_URL}/api/koho-proxy/invoices`, {
    withCredentials: true,
    params: { limit: 200, ...params },
  });

export const getKohoWorkSessions = (params = {}) =>
  axios.get(`${API_URL}/api/koho-proxy/work_sessions`, {
    withCredentials: true,
    params: { limit: 500, ...params },
  });

export const getKohoEmployees = (params = {}) =>
  axios.get(`${API_URL}/api/koho-proxy/employees`, {
    withCredentials: true,
    params: { archived: false, ...params },
  });

export const getKohoOffers = (params = {}) =>
  axios.get(`${API_URL}/api/koho-proxy/offers`, {
    withCredentials: true,
    params: { limit: 100, ...params },
  });

export const getKohoOffersByCustomer = (customerId) =>
  axios.get(`${API_URL}/api/koho-proxy/offers/find_by_customer/${customerId}`, {
    withCredentials: true,
  });

export const getKohoLeads = (params = {}) =>
  axios.get(`${API_URL}/api/koho-proxy/offers/leads`, {
    withCredentials: true,
    params: { limit: 100, ...params },
  });

export const getKohoCustomerCategories = () =>
  axios.get(`${API_URL}/api/koho-proxy/customers/categories`, {
    withCredentials: true,
  });

export const getKohoContracts = (params = {}) =>
  axios.get(`${API_URL}/api/koho-proxy/contracts`, {
    withCredentials: true,
    params: { limit: 100, ...params },
  });

export const getKohoAllCustomers = (params = {}) =>
  axios.get(`${API_URL}/api/koho-proxy/customers`, {
    withCredentials: true,
    params: { active: true, limit: 500, ...params },
  });

export const getKohoAllOffers = (params = {}) =>
  axios.get(`${API_URL}/api/koho-proxy/offers`, {
    withCredentials: true,
    params: { limit: 500, ...params },
  });

export const getKohoAssignments = (params = {}) =>
  axios.get(`${API_URL}/api/koho-proxy/work_session/assignments`, {
    withCredentials: true,
    params: { limit: 100, ...params },
  });

export const getKohoProjectPlannedLoads = (projectId) =>
  axios.get(`${API_URL}/api/koho-proxy/projects/${projectId}/planned_loads`, {
    withCredentials: true,
  });

export const getKohoEmployeeById = (employeeId) =>
  axios.get(`${API_URL}/api/koho-proxy/employees/${employeeId}`, {
    withCredentials: true,
  });

export const getKohoEmployeeFlexHours = (employeeId) =>
  axios.get(`${API_URL}/api/koho-proxy/employees/flex_hours`, {
    withCredentials: true,
    params: { 'ids[]': employeeId, long: true },
  });

export const getKohoEmployeeInvoicingBreakdown = (employeeId, termStart, termEnd) =>
  axios.get(`${API_URL}/api/koho-proxy/report/employee_invoicing_breakdown`, {
    withCredentials: true,
    params: { employee_id: employeeId, term_start: termStart, term_end: termEnd, json: true },
  });

export const getKohoShifts = (params = {}) =>
  axios.get(`${API_URL}/api/koho-proxy/work_session/shifts`, {
    withCredentials: true,
    params: { limit: 200, ...params },
  });

export const getKohoExpenses = (params = {}) =>
  axios.get(`${API_URL}/api/koho-proxy/expenses`, {
    withCredentials: true,
    params: { limit: 100, ...params },
  });

export const getKohoProjectTasksByCustomer = (customerId) =>
  axios.get(`${API_URL}/api/koho-proxy/project_tasks/find_by_customer/${customerId}`, {
    withCredentials: true,
  });

export const getKohoInvoiceTermsByContract = (contractId) =>
  axios.get(`${API_URL}/api/koho-proxy/invoice_terms/find_by_contract/${contractId}`, {
    withCredentials: true,
  });

export const getKohoInvoicePendingSessions = (projectId) =>
  axios.get(`${API_URL}/api/koho-proxy/projects/${projectId}/invoice_pending_sessions`, {
    withCredentials: true,
  });

export const getReportNote = (reportId) =>
  axios.get(`${API_URL}/api/report-notes/${reportId}`, { withCredentials: true });

export const saveReportNote = (reportId, content) =>
  axios.put(`${API_URL}/api/report-notes/${reportId}`, { content }, { withCredentials: true });
// Image subcategories
export const getImageSubcategories = (image_category) =>
  axios.get(`${API_URL}/api/image-subcategories`, { params: { image_category }, withCredentials: true });

export const createImageSubcategory = (data) =>
  axios.post(`${API_URL}/api/image-subcategories`, data, { withCredentials: true });

export const deleteImageSubcategory = (id) =>
  axios.delete(`${API_URL}/api/image-subcategories/${id}`, { withCredentials: true });

// Dynamic PTS
export const getDynamicPTSProjects = (id_kiinteisto) =>
  axios.get(`${API_URL}/api/dynamic-pts/${id_kiinteisto}/projects`, { withCredentials: true });

export const createDynamicPTSProject = (id_kiinteisto, name, year) =>
  axios.post(`${API_URL}/api/dynamic-pts/${id_kiinteisto}/projects`, { name, year }, { withCredentials: true });

export const getDynamicPTS = (project_id) =>
  axios.get(`${API_URL}/api/dynamic-pts/project/${project_id}`, { withCredentials: true });

export const saveDynamicPTS = (project_id, sections, name) =>
  axios.post(`${API_URL}/api/dynamic-pts/project/${project_id}/save`, { sections, name }, { withCredentials: true });

export const deleteDynamicPTSProject = (project_id) =>
  axios.delete(`${API_URL}/api/dynamic-pts/project/${project_id}`, { withCredentials: true });

// Mittaustaulukot
export const getMittausProjektitByPTS = (pts_project_id, tyyppi) =>
  axios.get(`${API_URL}/api/dynamic-pts/project/${pts_project_id}/mittaukset`, { withCredentials: true, params: tyyppi ? { tyyppi } : {} });

export const createMittausProjekti = (pts_project_id, tyyppi, nimi, options = {}) =>
  axios.post(`${API_URL}/api/dynamic-pts/project/${pts_project_id}/mittaukset`, { tyyppi, nimi, ...options }, { withCredentials: true });

export const updateMittausProjektiMeta = (id, payload) =>
  axios.put(`${API_URL}/api/mittaukset/project/${id}`, payload, { withCredentials: true });

export const getMittausProjekti = (id) =>
  axios.get(`${API_URL}/api/mittaukset/project/${id}`, { withCredentials: true });

export const getSiblingMittausProjekti = (id, tyyppi) =>
  axios.get(`${API_URL}/api/mittaukset/project/${id}/sibling`, { params: { tyyppi }, withCredentials: true });

export const renameMittausProjekti = (id, nimi) =>
  axios.put(`${API_URL}/api/mittaukset/project/${id}`, { nimi }, { withCredentials: true });

export const deleteMittausProjekti = (id) =>
  axios.delete(`${API_URL}/api/mittaukset/project/${id}`, { withCredentials: true });

export const deleteMittausProjektiWithSiblings = (id) =>
  axios.delete(`${API_URL}/api/mittaukset/project/${id}/with-siblings`, { withCredentials: true });

export const createMittausKohde = (mittaus_projekti_id, nimi, jarjestys = 0, nayte_id = null) =>
  axios.post(`${API_URL}/api/mittaukset/project/${mittaus_projekti_id}/kohteet`, { nimi, jarjestys, data: [], nayte_id }, { withCredentials: true });

export const updateMittausKohde = (id, payload) =>
  axios.put(`${API_URL}/api/mittaukset/kohteet/${id}`, payload, { withCredentials: true });

export const deleteMittausKohde = (id) =>
  axios.delete(`${API_URL}/api/mittaukset/kohteet/${id}`, { withCredentials: true });

// Naytteet
export const getNaytteetByProjekti = (projekti_id) =>
  axios.get(`${API_URL}/api/mittaukset/project/${projekti_id}/naytteet`, { withCredentials: true });

export const createNayte = (projekti_id, body) =>
  axios.post(`${API_URL}/api/mittaukset/project/${projekti_id}/naytteet`, body, { withCredentials: true });

export const getNayte = (id) =>
  axios.get(`${API_URL}/api/mittaukset/naytteet/${id}`, { withCredentials: true });

export const updateNayte = (id, body) =>
  axios.put(`${API_URL}/api/mittaukset/naytteet/${id}`, body, { withCredentials: true });

export const deleteNayte = (id) =>
  axios.delete(`${API_URL}/api/mittaukset/naytteet/${id}`, { withCredentials: true });

export const syncNayte = (id) =>
  axios.post(`${API_URL}/api/mittaukset/naytteet/${id}/sync`, {}, { withCredentials: true });

export const getValmislauseTagit = () =>
  axios.get(`${API_URL}/api/valmislauseet/tagit`, { withCredentials: true });

export const createValmislauseTag = (nimi) =>
  axios.post(`${API_URL}/api/valmislauseet/tagit`, { nimi }, { withCredentials: true });

export const deleteValmislauseTag = (id) =>
  axios.delete(`${API_URL}/api/valmislauseet/tagit/${id}`, { withCredentials: true });

export const getValmislauseet = (tag_id) =>
  axios.get(`${API_URL}/api/valmislauseet/tagit/${tag_id}/lauseet`, { withCredentials: true });

export const createValmislause = (tag_id, payload) =>
  axios.post(`${API_URL}/api/valmislauseet/tagit/${tag_id}/lauseet`, payload, { withCredentials: true });

export const updateValmislause = (id, payload) =>
  axios.put(`${API_URL}/api/valmislauseet/lauseet/${id}`, payload, { withCredentials: true });

export const deleteValmislause = (id) =>
  axios.delete(`${API_URL}/api/valmislauseet/lauseet/${id}`, { withCredentials: true });

export const reorderValmislauseet = (tag_id, ordered_ids) =>
  axios.put(`${API_URL}/api/valmislauseet/tagit/${tag_id}/reorder`, { ordered_ids }, { withCredentials: true });

export const setValmislauseTagReportTypes = (tag_id, reportTypes) =>
  axios.put(`${API_URL}/api/valmislauseet/tagit/${tag_id}/report-types`, { report_types: reportTypes }, { withCredentials: true });

export const setValmislauseTagSections = (tag_id, sections) =>
  axios.put(`${API_URL}/api/valmislauseet/tagit/${tag_id}/sections`, { sections }, { withCredentials: true });

// ---- LLM prompts (/api/llm/prompts) ----
// userId: whose personal line to act on (admins only for someone else; omit = self)
const llmPromptUrl = (key) => `${API_URL}/api/llm/prompts/${encodeURIComponent(key)}`;
const userParams = (userId) => (userId ? { user_id: userId } : {});

// opts: { reportType, archived } — reportType filters to that type + universal prompts
export const getLlmPrompts = (userId, { reportType, archived } = {}) =>
  axios.get(`${API_URL}/api/llm/prompts`, {
    params: { ...userParams(userId), report_type: reportType || undefined, archived: archived ? 'true' : undefined },
    withCredentials: true,
  });

export const getLlmReportTypes = () =>
  axios.get(`${API_URL}/api/llm/prompts/report-types`, { withCredentials: true });

export const setLlmPromptReportTypes = (key, reportTypes) =>
  axios.put(`${llmPromptUrl(key)}/report-types`, { report_types: reportTypes }, { withCredentials: true });

// "Delete" = archive: hidden from the dashboard and generation, history kept, restorable.
export const archiveLlmPrompt = (key) =>
  axios.post(`${llmPromptUrl(key)}/archive`, {}, { withCredentials: true });

export const archiveLlmPromptGroup = (groupName) =>
  axios.post(`${API_URL}/api/llm/prompts/archive-group`, { group_name: groupName }, { withCredentials: true });

export const restoreLlmPrompt = (key) =>
  axios.post(`${llmPromptUrl(key)}/restore`, {}, { withCredentials: true });

export const getLlmPromptState = (key, userId) =>
  axios.get(llmPromptUrl(key), { params: userParams(userId), withCredentials: true });

export const getLlmPromptHistory = (key, scope, userId) =>
  axios.get(`${llmPromptUrl(key)}/history`, { params: { scope, ...userParams(userId) }, withCredentials: true });

export const getLlmPromptVersion = (versionId) =>
  axios.get(`${API_URL}/api/llm/prompts/versions/${versionId}`, { withCredentials: true });

// payload: { scope: 'universal'|'personal', rows: [{item_id?, heading, content}], excluded_item_ids, note, base_version_id }
export const saveLlmPromptVersion = (key, payload, userId) =>
  axios.post(`${llmPromptUrl(key)}/versions`, { ...payload, ...userParams(userId) }, { withCredentials: true });

export const createLlmPersonalPrompt = (key, userId) =>
  axios.post(`${llmPromptUrl(key)}/personal`, userParams(userId), { withCredentials: true });

export const setLlmPersonalPromptActive = (key, isActive, userId) =>
  axios.patch(`${llmPromptUrl(key)}/personal`, { is_active: isActive, ...userParams(userId) }, { withCredentials: true });

// decisions: { [item_id]: 'theirs' | 'mine' }
export const mergeLlmPromptFromUniversal = (key, decisions, baseVersionId, userId) =>
  axios.post(`${llmPromptUrl(key)}/personal/merge`, { decisions, base_version_id: baseVersionId, ...userParams(userId) }, { withCredentials: true });

// Examples: live links to report sections (report_id + section_type), parsed on use.
export const getLlmPromptExamples = (key) =>
  axios.get(`${llmPromptUrl(key)}/examples`, { withCredentials: true });

// state: reports.state ('ready' | 'draft' | 'archived'), empty = all
// teamUser: 'me' or a kayttajatiedot id; teamSystem: role key (koordinaattori, lvia, …)
export const getLlmExampleCandidates = ({ key, reportType, state, teamUser, teamSystem, q, limit }) =>
  axios.get(`${API_URL}/api/llm/prompts/example-candidates`, {
    params: {
      key, report_type: reportType || undefined, state: state || undefined,
      team_user: teamUser || undefined, team_system: teamSystem || undefined,
      q: q || undefined, limit,
    },
    withCredentials: true,
  });

// Node tree of one report for the example picker (used nodes of `key` are marked).
export const getLlmExampleStructure = (reportId, key) =>
  axios.get(`${API_URL}/api/llm/prompts/example-structure/${reportId}`, { params: { key }, withCredentials: true });

// payload: { report_id, section_type?, block_id?, label? }
//   no section_type = whole report; section_type only = that section; + block_id = that subsection / text area
export const addLlmPromptExample = (key, payload) =>
  axios.post(`${llmPromptUrl(key)}/examples`, payload, { withCredentials: true });

// patch: { is_active?, label? }
export const updateLlmPromptExample = (id, patch) =>
  axios.patch(`${API_URL}/api/llm/prompts/examples/${id}`, patch, { withCredentials: true });

export const deleteLlmPromptExample = (id) =>
  axios.delete(`${API_URL}/api/llm/prompts/examples/${id}`, { withCredentials: true });

export const restoreLlmPromptVersion = (versionId) =>
  axios.post(`${API_URL}/api/llm/prompts/versions/${versionId}/restore`, {}, { withCredentials: true });

// ---- Text recommendations (/api/text-recommendations) ----
// Separate feature from LLM prompts above — reuses the same report-section/
// block addressing convention (section_type + block_id/block_label) but is
// its own endpoint family, own settings, own admin page.

// Global config: { enabled, year_range, ready_only, max_suggestions }
export const getTextRecommendationSettings = () =>
  axios.get(`${API_URL}/api/text-recommendations/settings`, { withCredentials: true });

export const updateTextRecommendationSettings = (payload) =>
  axios.put(`${API_URL}/api/text-recommendations/settings`, payload, { withCredentials: true });

// Personal overrides for the current user — any of ready_only/year_range/
// match_rakennusluokitus/max_suggestions left out (null) falls back to the
// admin default above; exclude_user_ids is additive to the admin's global
// list, not a replacement. Admin-only for now (same temporary rollout gate
// as getTextRecommendations below).
export const getMyTextRecommendationSettings = () =>
  axios.get(`${API_URL}/api/text-recommendations/my-settings`, { withCredentials: true });

export const updateMyTextRecommendationSettings = (payload) =>
  axios.put(`${API_URL}/api/text-recommendations/my-settings`, payload, { withCredentials: true });

// Finds other non-template reports of the same type as `reportId`, whose
// kiinteistö's main-building rakennusvuosi is within the configured ± range,
// and returns each match's text for the SAME section/subsection/block slot
// (section_type + block_id, block_label as fallback — same addressing
// convention as the LLM-example feature's `block_id`/`block_label`).
// Returns [] (not an error) when the feature is disabled or nothing matches.
export const getTextRecommendations = ({ reportId, sectionType, blockId, blockLabel, excludeReportIds }) =>
  axios.get(`${API_URL}/api/text-recommendations`, {
    params: {
      report_id: reportId, section_type: sectionType, block_id: blockId, block_label: blockLabel,
      exclude_report_ids: excludeReportIds?.length ? excludeReportIds.join(',') : undefined,
    },
    withCredentials: true,
  });

// Picker for Kansilehti's "primary template report" override. With `q` blank,
// returns the "Suositellut" list — other reports of `reportType` within the
// configured ± building-year range of `reportId`'s kiinteistö, closest first
// (same matching as getTextRecommendations, via candidatesByAge). With `q`
// set, a free-text search (name/kohteen_nimi, or a bare id/id_kiinteisto).
export const searchTextRecommendationReports = ({ reportId, q, reportType }) =>
  axios.get(`${API_URL}/api/text-recommendations/report-search`, {
    params: { report_id: reportId, q, type: reportType },
    withCredentials: true,
  });

// Picker for the Tekstisuositukset settings page's "ohita nämä kohteet"
// (exclude_kiinteisto_ids) — admin-only, free-text over kohteen_nimi/kiinteistotunnus.
// `ids` (instead of `q`) resolves specific saved ids to display labels.
export const searchTextRecommendationKiinteistot = ({ q, ids }) =>
  axios.get(`${API_URL}/api/text-recommendations/kiinteisto-search`, {
    params: { q, ids: ids?.length ? ids.join(",") : undefined },
    withCredentials: true,
  });

export const getMmlTileStats = ({ from, to, granularity } = {}) => {
  const params = {};
  if (from) params.from = from;
  if (to) params.to = to;
  if (granularity) params.granularity = granularity;
  return axios.get(`${API_URL}/api/admin/tile-stats`, { params, withCredentials: true });
};

export const getMmlTileLogs = (params = {}) =>
  axios.get(`${API_URL}/api/admin/tile-logs`, { params, withCredentials: true });

export const getApiRequestLogs = (params = {}) =>
  axios.get(`${API_URL}/api/admin/request-logs`, { params, withCredentials: true });

// ─── Julkisivu report v2 ─────────────────────────────────────────────
// New, standalone endpoints (kuntoarviovalikko → tarkastuskohde → rakenneosa
// → poranäyte/peitepaksuus/testi). Separate from the mittaukset/* functions
// above — nothing here touches the old poranäyte/peitepaksuus data model.

export const getJulkisivuOptions = () =>
  axios.get(`${API_URL}/api/julkisivu/options`, { withCredentials: true });

export const getKategoriat = () =>
  axios.get(`${API_URL}/api/julkisivu/options/kategoriat`, { withCredentials: true });

export const getRakenneosaTyypit = () =>
  axios.get(`${API_URL}/api/julkisivu/options/rakenneosa-tyypit`, { withCredentials: true });

export const getTestiTyypit = () =>
  axios.get(`${API_URL}/api/julkisivu/options/testi-tyypit`, { withCredentials: true });

export const getProjectDebugDump = (ptsId) =>
  axios.get(`${API_URL}/api/julkisivu/pts-projects/${ptsId}/debug-dump`, { withCredentials: true });

export const getKarbPinta = () =>
  axios.get(`${API_URL}/api/julkisivu/options/karb-pinta`, { withCredentials: true });

export const createKuntoarviovalikko = (ptsId, category) =>
  axios.post(`${API_URL}/api/julkisivu/pts-projects/${ptsId}/kuntoarviovalikko`, { category }, { withCredentials: true });

export const getKuntoarviovalikot = (ptsId) =>
  axios.get(`${API_URL}/api/julkisivu/pts-projects/${ptsId}/kuntoarviovalikko`, { withCredentials: true });

export const createTarkastuskohdeV2 = (kavId, nimi, reportId) =>
  axios.post(`${API_URL}/api/julkisivu/kuntoarviovalikko/${kavId}/tarkastuskohteet`, { nimi, report_id: reportId }, { withCredentials: true });

// For a tarkastuskohde that already exists in the julkisivu/kuntoarvio
// project data (e.g. created from the standalone taloyhtiökortti
// workspace, which has no report to attach a section to) — creates ONLY
// the report_section, reusing the same clone-into-report_sections logic
// createTarkastuskohdeV2 already runs when report_id is set, without
// touching tarkastuskohde data at all (tarkastuskohde and report section
// are different things — this must never create/duplicate a
// tarkastuskohde, only the section). Same response contract:
// {section, section_order, section_skipped_reason}.
// NOTE (2026-10-02): backend route not yet implemented — see plan.
export const createSectionForTarkastuskohdeV2 = (tkId, reportId) =>
  axios.post(`${API_URL}/api/julkisivu/tarkastuskohteet/${tkId}/create_section`, { report_id: reportId }, { withCredentials: true });

export const getTarkastuskohteetV2 = (kavId) =>
  axios.get(`${API_URL}/api/julkisivu/kuntoarviovalikko/${kavId}/tarkastuskohteet`, { withCredentials: true });

export const updateTarkastuskohdeV2 = (id, payload) =>
  axios.patch(`${API_URL}/api/julkisivu/tarkastuskohteet/${id}`, payload, { withCredentials: true });

export const deleteTarkastuskohdeV2 = (id) =>
  axios.delete(`${API_URL}/api/julkisivu/tarkastuskohteet/${id}`, { withCredentials: true });

export const createRakenneosaV2 = (tkId, nimi, tyyppi) =>
  axios.post(`${API_URL}/api/julkisivu/tarkastuskohteet/${tkId}/rakenneosat`, { nimi, tyyppi }, { withCredentials: true });

export const getRakenneosatV2 = (tkId) =>
  axios.get(`${API_URL}/api/julkisivu/tarkastuskohteet/${tkId}/rakenneosat`, { withCredentials: true });

export const getRakenneosaV2 = (id) =>
  axios.get(`${API_URL}/api/julkisivu/rakenneosat/${id}`, { withCredentials: true });

export const updateRakenneosaV2 = (id, payload) =>
  axios.patch(`${API_URL}/api/julkisivu/rakenneosat/${id}`, payload, { withCredentials: true });

export const deleteRakenneosaV2 = (id) =>
  axios.delete(`${API_URL}/api/julkisivu/rakenneosat/${id}`, { withCredentials: true });

export const createPoranayteV2 = (rakId, payload) =>
  axios.post(`${API_URL}/api/julkisivu/rakenneosat/${rakId}/poranaytteet`, payload, { withCredentials: true });

export const getPoranaytteetV2 = (rakId) =>
  axios.get(`${API_URL}/api/julkisivu/rakenneosat/${rakId}/poranaytteet`, { withCredentials: true });

export const getPoranaytteetByTarkastuskohdeV2 = (tkId) =>
  axios.get(`${API_URL}/api/julkisivu/tarkastuskohteet/${tkId}/poranaytteet`, { withCredentials: true });

export const updatePoranayteV2 = (id, payload) =>
  axios.patch(`${API_URL}/api/julkisivu/poranaytteet/${id}`, payload, { withCredentials: true });

export const deletePoranayteV2 = (id) =>
  axios.delete(`${API_URL}/api/julkisivu/poranaytteet/${id}`, { withCredentials: true });

export const getPeitepaksuusV2 = (rakId) =>
  axios.get(`${API_URL}/api/julkisivu/rakenneosat/${rakId}/peitepaksuus`, { withCredentials: true });

export const getPeitepaksuusByTarkastuskohdeV2 = (tkId) =>
  axios.get(`${API_URL}/api/julkisivu/tarkastuskohteet/${tkId}/peitepaksuus`, { withCredentials: true });

export const updatePeitepaksuusV2 = (id, payload) =>
  axios.patch(`${API_URL}/api/julkisivu/peitepaksuus/${id}`, payload, { withCredentials: true });

export const createPeitepaksuusArvoV2 = (peiteId, arvo_mm) =>
  axios.post(`${API_URL}/api/julkisivu/peitepaksuus/${peiteId}/arvot`, { arvo_mm }, { withCredentials: true });

export const getPeitepaksuusArvotV2 = (peiteId) =>
  axios.get(`${API_URL}/api/julkisivu/peitepaksuus/${peiteId}/arvot`, { withCredentials: true });

export const replacePeitepaksuusArvotV2 = (peiteId, values) =>
  axios.put(`${API_URL}/api/julkisivu/peitepaksuus/${peiteId}/arvot`, { values }, { withCredentials: true });

export const deletePeitepaksuusArvoV2 = (id) =>
  axios.delete(`${API_URL}/api/julkisivu/peitepaksuus-arvot/${id}`, { withCredentials: true });

export const updatePeitepaksuusArvoV2 = (id, arvo_mm) =>
  axios.patch(`${API_URL}/api/julkisivu/peitepaksuus-arvot/${id}`, { arvo_mm }, { withCredentials: true });

export const createTestiV2 = (poraId, tyyppi, arvo) =>
  axios.post(`${API_URL}/api/julkisivu/poranaytteet/${poraId}/testit`, { tyyppi, arvo }, { withCredentials: true });

export const getTestitV2 = (poraId) =>
  axios.get(`${API_URL}/api/julkisivu/poranaytteet/${poraId}/testit`, { withCredentials: true });

export const updateTestiV2 = (id, payload) =>
  axios.patch(`${API_URL}/api/julkisivu/testit/${id}`, payload, { withCredentials: true });

export const deleteTestiV2 = (id) =>
  axios.delete(`${API_URL}/api/julkisivu/testit/${id}`, { withCredentials: true });

export const getTestiCaptionV2 = (tkId, tyyppi) =>
  axios.get(`${API_URL}/api/julkisivu/tarkastuskohteet/${tkId}/testit/${tyyppi}/caption`, { withCredentials: true });

export const updateTestiCaptionV2 = (tkId, tyyppi, caption) =>
  axios.patch(`${API_URL}/api/julkisivu/tarkastuskohteet/${tkId}/testit/${tyyppi}/caption`, { caption }, { withCredentials: true });
